module.exports = __webpack_public_path__ + "img/2-2.5a4b9977.svg";